export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-3.ab59b712.png";